import React from 'react';
import styles from './Tutorials.module.css';

const Tutorials = () => {
  const tutorials = [
    {
      id: 1,
      title: 'Getting Started with Rupayya',
      videoId: 'abc123',
      thumbnail: '/Thumbnail/image1.png'
    },
    {
      id: 2,
      title: 'How to Create Your First Loan',
      videoId: 'def456',
      thumbnail: '/Thumbnail/image2.png'
    },
    {
      id: 3,
      title: 'Verification Process Guide',
      videoId: 'ghi789',
      thumbnail: '/Thumbnail/image3.png'
    },
    {
      id: 4,
      title: 'Understanding Interest Rates',
      videoId: 'jkl012',
      thumbnail: '/Thumbnail/image4.png'
    },
    {
      id: 5,
      title: 'Repayment Schedule Explained',
      videoId: 'mno345',
      thumbnail: '/Thumbnail/image5.png'
    },
    {
      id: 6,
      title: 'Security Features Overview',
      videoId: 'pqr678',
      thumbnail: '/Thumbnail/image6.png'
    },
    {
      id: 7,
      title: 'Mobile App Tutorial',
      videoId: 'stu901',
      thumbnail: '/Thumbnail/image7.png'
    },
    {
      id: 8,
      title: 'Managing Your Profile',
      videoId: 'vwx234',
      thumbnail: '/Thumbnail/image8.png'
    },
    {
      id: 9,
      title: 'KYC Process Simplified',
      videoId: 'yzab567',
      thumbnail: '/Thumbnail/image9.png'
    },
    {
      id: 10,
      title: 'Transaction History Guide',
      videoId: 'cdef890',
      thumbnail: '/Thumbnail/image10.png'
    },
    {
      id: 11,
      title: 'Privacy Settings Tutorial',
      videoId: 'ghij123',
      thumbnail: '/Thumbnail/image11.png'
    },
    {
      id: 12,
      title: 'Contacting Support',
      videoId: 'klmn456',
      thumbnail: '/Thumbnail/image12.png'
    }
  ];

  const handleWatchTutorial = (videoId) => {
    // You can implement modal or redirect to YouTube
    window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        
        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>Video Tutorials</h1>
          <p className={styles.subtitle}>Learn how to use Rupayya with our step-by-step tutorials</p>
        </div>

        {/* Tutorials Grid */}
        <div className={styles.tutorialsGrid}>
          {tutorials.map((tutorial) => (
            <div key={tutorial.id} className={styles.tutorialCard}>
              <div className={styles.thumbnailContainer}>
                <img 
                  src={tutorial.thumbnail} 
                  alt={tutorial.title}
                  className={styles.thumbnail}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/Thumbnail/default.png';
                  }}
                />
                <div className={styles.playOverlay}>
                  <div className={styles.playIcon}>▶</div>
                </div>
              </div>
              
              <div className={styles.tutorialInfo}>
                <h3 className={styles.tutorialTitle}>{tutorial.title}</h3>
                <button 
                  className={styles.watchButton}
                  onClick={() => handleWatchTutorial(tutorial.videoId)}
                >
                  Watch Tutorial
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          <p className={styles.footerText}>
            Can't find what you're looking for? <a href="/contact" className={styles.contactLink}>Contact our support team</a>
          </p>
        </div>

      </div>
    </div>
  );
};

export default Tutorials;